import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import logo from '../../ssl-logo.png';

import SideScreenOverlay from '../sections/SideScreenOverlay';
import LoadingAnimation from '../UIComponents/LoadingAnimation';
function AboutPage(){
    return (
        <> 
            <Row>
                <Col className="bg-dark">
                    <img src="/ssl-logo-white.png" className="App-logo" alt="logo" />
                    <p>
                    ...coming soon
                    </p>
                </Col>
            </Row>

            <Row>
                <Col md={{ span: 8, offset: 2}}>

                    <h1 className="text-font-body text-font-size-large text-font-heavy text-start">About Sunset Liquor</h1>

                    <p className="text-font-body text-font-size-medium text-font-light text-start">Sunset Liquor is NOT just your regular mom n pop liquor store. We're a neighborhood staple. We're a gathering place built on relationships, community, and genuine hospitality.</p>

                    <p className="text-font-body text-font-size-medium text-font-light text-start">Sunset Liquor was acquired and purchased by Nelle Tatum and family. As the current owners, they hold a simple belief: successful local businesses are built through adding value to the community it serves and treating people like family. Every bottle on our shelves, every recommendation we make, and every event we host reflects our commitment to creating an experience that goes beyond a transaction. When customers walk through our doors, the atmosphere should feel like you're stopping by to visit familiar friends.</p>

                    <p className="text-font-body text-font-size-medium text-font-light text-start">Our team, our village: Grandma Phyllis, Pops, Gigi,  Nelle, Shoney, Moriah, Princess, Darlene, Andrew, Trivia, and Alayna are dedicated to supporting and creating an in store experience where we learn and share product knowledge that helps customers discover new favorites and find the perfect picks to celebrate life's special moments. From, Taste it Thursdays, Fri-Ya Shots</p>
                    <p className="text-font-body text-font-size-medium text-font-light text-start">&</p>
                    <p className="text-font-body text-font-size-medium text-font-light text-start">Sip & See Saturdays </p>
                    <p className="text-font-body text-font-size-medium text-font-light text-start">We're creating a welcoming atmosphere where everyone feels at home as soon as they walk through the door. Whether searching for the perfect bottle, exploring something new, or simply stopping by to say hello, there is always find a friendly face and a helping hand at Sunset Liquor.</p>
                    <p className="text-font-body text-font-size-medium text-font-light text-start">While growth matters, people matter more. We choose relationships over transactions and service over shortcuts. We measure the success of Sunset Liquor not only by what we earn, but by the positive impact we make through our customer and community interactions.</p>

                    <p className="text-font-body text-font-size-medium text-font-light text-start">We're proud to be your neighborhood liquor store.</p>

                    <p className="text-font-body text-font-size-medium text-font-light text-start">Good Spirits & Good Vibes</p>

                    <h2 className="text-font-body text-font-size-large text-font-medium text-start">Core Values Are:</h2>

                    <h3 className="text-font-body text-font-size-large text-font-light text-start">Relentless Work Ethic</h3>
                    <p className="text-font-body text-font-size-medium text-font-light text-start">We outwork doubt, distractions, and the competition—consistency is our unfair advantage.</p>

                    <h3 className="text-font-body text-font-size-large text-font-light text-start">Build Self. Elevate the Tribe. Impact the Community.</h3>
                    <p className="text-font-body text-font-size-medium text-font-light text-start">Personal mastery comes first, then we rise together, then we give back at scale.</p>

                    <h3 className="text-font-body text-font-size-large text-font-light text-start">Spirit-Led Foundation</h3>
                    <p className="text-font-body text-font-size-medium text-font-light text-start">We move with purpose, guided by faith, alignment, and something bigger than ourselves.</p>

                    <h3 className="text-font-body text-font-size-large text-font-light text-start">Peace Over Profit</h3>
                    <p className="text-font-body text-font-size-medium text-font-light text-start">No deal, dollar, or opportunity is worth disrupting our peace—clarity and alignment always win.</p>




                </Col>
            </Row>
        </>
    )
}

export default AboutPage;